import React from 'react'
import { Box, Typography, Link, Grid } from '@mui/material'

import Toya from '@/shared/assets/icons/FooterToya/toya.png'
import dtIcon from '@/shared/assets/icons/FooterToya/dt.png'
import StudiosGray from '@/shared/assets/icons/FooterToya/studios_gray.png'
import ToyaLogo from '@/shared/assets/icons/FooterToya/toya_logo.png'
import TVToya from '@/shared/assets/icons/FooterToya/tvtoya.png'
import Unia from '@/shared/assets/icons/FooterToya/unia.png'
import Wytwornia from '@/shared/assets/icons/FooterToya/wytwornia.png'

export const Footer: React.FC = () => (
    <Box>
        <Box
            component="footer"
            sx={{
                color: '#fff', // White text
                padding: '20px 0',
                textAlign: 'center',
            }}>
            <Box>
                <Typography variant="body2" color="#A7A7A7">
                    Krajowa Rada Radiofonii i Telewizji jest organem właściwym w
                    sprawach audiowizualnych usług medialnych na żądanie.
                </Typography>
            </Box>
            <Box>
                <Typography variant="body2" color="#A7A7A7">
                    Krajowa Rada Radiofonii i Telewizji, Skwer Ks. Kardynała
                    Stefana Wyszyńskiego 9, 01-015 Warszawa, tel. (22)
                    597-30-00, fax (22) 597-31-80,{' '}
                    <Link
                        sx={{
                            color: '#A7A7A7 !important',
                        }}
                        href="https://www.gov.pl/web/krrit"
                        underline="none">
                        www.krrit.gov.pl
                    </Link>
                </Typography>
            </Box>
        </Box>
        <Box
            component="footer"
            sx={{
                color: '#fff', // White text
                padding: '20px 0',
                borderTop: '1px solid #333', // Subtle top border
                textAlign: 'center',
            }}>
            {/* Top Section with Logos */}
            <Box
                sx={{
                    display: 'flex',
                    paddingBottom: '16px',
                }}>
                <Grid
                    container
                    spacing={2}
                    justifyContent="flex-start"
                    alignItems="center">
                    <Grid
                        item
                        sx={{
                            margin: '0 15px 0 15px',
                            display: 'flex',
                        }}>
                        <Link
                            href="https://toya.net.pl/grupatoya"
                            target="_blank"
                            underline="none">
                            <img
                                src={Toya}
                                alt="Toya Group"
                                style={{
                                    height: '15px',
                                    filter: 'invert(100%)',
                                }}
                            />
                        </Link>
                    </Grid>
                    <Grid
                        item
                        sx={{
                            margin: '0 15px 0 15px',
                            display: 'flex',
                        }}>
                        <Link
                            href="//toya.net.pl"
                            target="_blank"
                            underline="none">
                            <img
                                src={ToyaLogo}
                                alt="Toya Logo"
                                style={{
                                    height: 30,
                                    filter: 'invert(100%)',
                                }}
                            />
                        </Link>
                    </Grid>
                    <Grid
                        item
                        sx={{
                            margin: '0 15px 0 15px',
                            display: 'flex',
                        }}>
                        <Link href="http://www.tvtoya.pl" underline="none">
                            <img
                                src={TVToya}
                                alt="TV Toya"
                                style={{
                                    height: 30,
                                    filter: 'invert(100%)',
                                }}
                            />
                        </Link>
                    </Grid>
                    <Grid
                        item
                        sx={{
                            margin: '0 15px 0 15px',
                            display: 'flex',
                        }}>
                        <Link
                            href="http://toyastudios.pl"
                            target="_blank"
                            underline="none">
                            <img
                                src={StudiosGray}
                                alt="Toya Studios"
                                style={{
                                    height: '20px',
                                    filter: 'invert(100%)',
                                }}
                            />
                        </Link>
                    </Grid>
                    <Grid
                        item
                        sx={{
                            margin: '0 15px 0 15px',
                            display: 'flex',
                        }}>
                        <Link
                            href="http://wytwornia.pl"
                            underline="none"
                            target="_blank">
                            <img
                                src={Wytwornia}
                                alt="Wytwornia"
                                style={{
                                    height: 30,
                                    filter: 'invert(100%)',
                                }}
                            />
                        </Link>
                    </Grid>
                    <Grid
                        item
                        sx={{
                            margin: '0 15px 0 15px',
                            display: 'flex',
                        }}>
                        <Link
                            href="http://doubletree3.hilton.com/en/hotels/poland/doubletree-by-hilton-hotel-lodz-LCJDLDI/index.html"
                            target="_blank"
                            underline="none">
                            <img
                                src={dtIcon}
                                alt="DoubleTree Hilton"
                                style={{
                                    height: 30,
                                    filter: 'invert(100%)',
                                }}
                            />
                        </Link>
                    </Grid>
                    <Grid item></Grid>
                </Grid>
                <Box>
                    <Link
                        sx={{
                            margin: '0 15px 0 15px',
                        }}
                        href="http://toya.net.pl/projekty-ue"
                        target="_blank"
                        underline="none">
                        <img
                            id="eu_regional_logo"
                            src={Unia}
                            alt="EU Regional"
                            style={{ height: 30, filter: 'invert(100%)' }}
                        />
                    </Link>
                </Box>
            </Box>
        </Box>
    </Box>
)
